export const PINNED_LEADING_FIELD_COUNT_PROPERTY = 'pinnedLeadingFieldCount';

export function getPinnedLeadingFieldCountFromProperties(
  properties: Readonly<Record<string, unknown>> | undefined
): number | undefined {
  const value = properties?.[PINNED_LEADING_FIELD_COUNT_PROPERTY];

  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return undefined;
  }

  return Math.max(0, Math.trunc(value));
}

export function setPinnedLeadingFieldCountInProperties(
  properties: Readonly<Record<string, unknown>> | undefined,
  pinnedLeadingFieldCount: number
): Record<string, unknown> | undefined {
  const nextProperties = { ...(properties ?? {}) };
  const nextPinnedLeadingFieldCount = Number.isFinite(pinnedLeadingFieldCount)
    ? Math.max(0, Math.trunc(pinnedLeadingFieldCount))
    : 0;

  if (nextPinnedLeadingFieldCount > 0) {
    nextProperties[PINNED_LEADING_FIELD_COUNT_PROPERTY] = nextPinnedLeadingFieldCount;
  } else {
    delete nextProperties[PINNED_LEADING_FIELD_COUNT_PROPERTY];
  }

  return Object.keys(nextProperties).length > 0 ? nextProperties : undefined;
}
